"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeType = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sbTextbox = require("../../sb-textbox");

var _sbStructuredFilterI18n = require("../sb-structured-filter-i18n");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RangeType = /*#__PURE__*/function (_Component) {
  _inherits(RangeType, _Component);

  var _super = _createSuper(RangeType);

  function RangeType(props) {
    var _this;

    _classCallCheck(this, RangeType);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (values) {
      var onChange = _this.props.onChange;
      onChange(values);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFromValueChange", function (event, _ref) {
      var floatValue = _ref.floatValue;
      _this.from = isNaN(floatValue) ? 0 : floatValue;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnToValueChange", function (event, _ref2) {
      var floatValue = _ref2.floatValue;
      _this.to = isNaN(floatValue) ? 0 : floatValue;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          from = _assertThisInitialize.from,
          to = _assertThisInitialize.to;

      _this.onChange({
        from: from,
        to: to
      });
    });

    _this.from = props.from;
    _this.to = props.to;
    return _this;
  }

  _createClass(RangeType, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          suffix = _this$props.suffix,
          inputsProps = _this$props.inputsProps,
          _ = _this$props.formatMessage;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("label", null, _(_sbStructuredFilterI18n.messages.from), /*#__PURE__*/_react.default.createElement(_sbTextbox.SbTextbox, _extends({
        className: "sb-width-xs",
        value: this.from,
        suffix: suffix,
        type: "number",
        selectOnFocus: true,
        onChange: this.handleOnFromValueChange,
        onBlur: this.handleOnBlur,
        fraction: 4,
        negative: false
      }, inputsProps, {
        isNumericString: true
      }))), /*#__PURE__*/_react.default.createElement("label", null, _(_sbStructuredFilterI18n.messages.to), /*#__PURE__*/_react.default.createElement(_sbTextbox.SbTextbox, _extends({
        className: "sb-width-xs",
        value: this.to,
        suffix: suffix,
        type: "number",
        selectOnFocus: true,
        onChange: this.handleOnToValueChange,
        onBlur: this.handleOnBlur,
        fraction: 4,
        negative: false
      }, inputsProps, {
        isNumericString: true
      }))));
    }
  }]);

  return RangeType;
}(_react.Component);

exports.RangeType = RangeType;

_defineProperty(RangeType, "propTypes", {
  from: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  to: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  inputsProps: _propTypes.default.object,
  // eslint-disable-line
  suffix: _propTypes.default.string,
  onChange: _propTypes.default.func,
  formatMessage: _propTypes.default.func.isRequired
});

_defineProperty(RangeType, "defaultProps", {
  from: 0,
  to: 0,
  inputsProps: {},
  suffix: '',
  onChange: function onChange() {}
});
//# sourceMappingURL=range-type.js.map